exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".backdrop{position:fixed;left:0;top:0;right:0;bottom:0;background:rgba(50,50,50,.8)}form.edit-note{position:relative;width:480px;max-width:100%;margin:25vh auto 0;padding:15px;background:#fff;border-radius:2px;box-shadow:0 1px 50px #555}form.edit-note input,form.edit-note textarea{width:100%;max-width:100%;border:0;padding:4px;outline:none;font-size:1.2em}form.edit-note button{border:0;margin:0 4px 0 0;font-size:20px;background:none;cursor:pointer;opacity:.6;transition:opacity .5s}form.edit-note button:focus,form.edit-note button:hover{opacity:1}form.edit-note button[type=submit]{float:right;border:0;margin:0;padding:4px 6px;font-size:18px;color:#fff;background:#41b883;border-radius:3px;cursor:pointer;opacity:1}.modal-transition{transition:opacity .3s ease;opacity:1}.modal-transition form{transition:transform .3s ease}.modal-enter,.modal-exit{opacity:0}.modal-enter form,.modal-exit form{transform:scale(1.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/notes/UpdateModal.scss
// module id = 131
// module chunks = 0